"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertBlockAfter = void 0;

var _draftJs = require("draft-js");

var insertBlockAfter = function insertBlockAfter(contentState
/* ContentState */
, afterKey
/* key in BlockMap */
, contentBlock
/* ContentBlock */
) {
  var blockArray = contentState.getBlocksAsArray();
  var arr = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = blockArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var block = _step.value;
      arr.push(block);

      if (afterKey === block.getKey()) {
        arr.push(contentBlock);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return contentState.set('blockMap', _draftJs.BlockMapBuilder.createFromArray(arr));
};

exports.insertBlockAfter = insertBlockAfter;